<script>
import { mapActions, mapGetters } from "vuex";

import AppTop from "@/components/ui/top.vue";
import AppBottom from "@/components/ui/bottom.vue";
import AppFloatList from "@/components/ui/float-list.vue";
import AppMore from "@/components/ui/more.vue";
import PopupConfirm from "@/components/ui/popup-confirm.vue";
import AppCookies from "@/components/ui/cookies.vue";

import AppSelfMed from "@/components/AppSelfMed.vue";

export default {
  name: "app",

  components: {
    AppTop,
    AppBottom,
    AppMore,
    AppFloatList,
    PopupConfirm,
    AppCookies,
    AppSelfMed,
  },

  data() {
    return {
      mobile: false,
      popup: true,
    };
  },

  computed: {
    ...mapGetters(["getIsMobile", "getConfirmPopup", "getCookiesPopup"]),
  },

  methods: {
    ...mapActions(["switchMobile", "switchConfirmPopup", "switchCookiesPopup"]),
  },

  mounted() {
    if (sessionStorage.getItem("confirmPopup")) {
      this.switchConfirmPopup(false);
    }

    let ua = navigator.userAgent.toLowerCase();
    let isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    let iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
      this.switchMobile(true);
    }
    if (
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform)
    ) {
      this.switchMobile(true);
    }

    if (isAndroid || iOS) {
      this.switchMobile(true);
    }

    // VH
    const getVH = () => window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${getVH()}px`);
    // SVH
    window.addEventListener("resize", () => {
      document.documentElement.style.setProperty("--svh", `${getVH()}px`);
    });

    if (localStorage.getItem("cookies") !== null) {
      this.switchCookiesPopup(false);
    }
  },
};
</script>

<template>
  <div class="wrapper" :class="[{ active: getIsMobile }]">
    <div class="star" :class="{ active: $route.name !== 'home' }">
      <AppTop :page="$route.name" />
      <router-view />
      <AppMore :page="$route.name" v-if="$route.name !== 'home'" />
      <AppSelfMed />
      <AppBottom />

      <!-- menu -->
      <AppFloatList v-if="$route.name !== 'home'" />

      <AppCookies />
      <PopupConfirm v-if="!getCookiesPopup && getConfirmPopup" />
    </div>
  </div>
</template>

<style lang="scss">
.js-scroll {
  opacity: 0;
}

.scrolled.fade-in-bottom {
  animation: fade-in-bottom 0.6s ease-in-out both;

  &.delay1 {
    animation-delay: 100ms;
  }

  &.delay2 {
    animation-delay: 200ms;
  }

  &.delay3 {
    animation-delay: 300ms;
  }

  &.delay4 {
    animation-delay: 400ms;
  }

  &.delay5 {
    animation-delay: 500ms;
  }
}

@keyframes fade-in-bottom {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes shake {
  0% {
    transform: rotateZ(0);
  }
  $pos: 1;
  @for $i from 1 through 9 {
    $pos: $pos * -1;
    $m: (50 / $i) * $pos;
    #{$i*10%} {
      transform: rotateZ($m * 1deg);
    }
  }
  100% {
    transform: rotateZ(0);
  }
}

.wrapper {
  padding-top: 60px;

  background: #164031;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  min-height: calc(100vh);
  min-height: calc((var(--svh, 1vh) * 100));
  position: relative;

  @media screen and (min-width: 1025px) {
    padding-top: 80px;
  }

  .star {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    min-height: calc(100vh - 60px);
    min-height: calc((var(--svh, 1vh) * 100) - 60px);
    position: relative;

    &.active {
      //background: url("@/assets/img/ui/star-d.png") repeat center;
      background-size: 100%;
    }

    @media screen and (max-width: 600px) {
      &.active {
        //background: url("@/assets/img/ui/star-t.png") repeat;
        background-size: 100%;
      }
    }

    @media screen and (max-width: 600px) {
      min-height: calc(100vh - 60px);
      min-height: calc((var(--svh, 1vh) * 100) - 60px);

      &.active {
        //background: url("@/assets/img/ui/star-m.png") repeat;
        background-size: 100%;
      }
    }
  }
}

.wrapper.active {
  cursor: none !important;
  outline: none !important;
}
</style>
